import { observer } from 'mobx-react'
import style from './Footer.module.css'

const Footer = observer(() => {
  const now = new Date()

  return (
    <div className={style.footer}>
      <div className={style.content}>
        &copy; ENEKA Energie &amp; Karten GmbH {now.getFullYear()}
      </div>
    </div>
  )
})

export default Footer
